import * as api from '@apis/auth';
import { User } from '@models/auth';
import { useAuthStore } from '@stores/authStore';
import { useMutation } from '@tanstack/react-query';
import { isAdmin } from '@utils/common';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSocket } from './appSocket';

export const useAuthentication = () => {
  useAppSocket();
  const authStore = useAuthStore();
  const navigate = useNavigate();

  const setUser = (user?: User) => {
    authStore.setUser(user);
  };

  const mutationLogin = useMutation({
    mutationFn: api.login,
    onSuccess: async () => {
      const response = await api.getMe();
      setUser(response.data);
    },
  });

  const mutationLogout = useMutation({
    mutationFn: api.logout,
    onSuccess: () => {
      setUser(undefined);
      navigate('/login');
    },
    onError: () => {
      setUser(undefined);
      navigate('/login');
    },
  });

  useEffect(() => {
    if (!authStore.user) {
      api
        .getMe()
        .then((response) => {
          if (!isAdmin(response.data.roles)) {
            setUser(undefined);
            mutationLogout.mutate();
            navigate('/login');
          } else {
            setUser(response.data);
          }
        })
        .catch(() => {
          api
            .refresh()
            .then(() => {
              api.getMe().then((response) => {
                setUser(response.data);
              });
            })
            .catch(() => {
              setUser(undefined);
              navigate('/login');
            });
        })
        .catch(() => {
          setUser(undefined);
          navigate('/login');
        });
    } else {
      if (!isAdmin(authStore.user.roles)) {
        setUser(undefined);
        navigate('/login');
      }
    }
  }, [authStore.user]);

  const logout = () => {
    mutationLogout.mutate();
  };

  return { authStore, login: mutationLogin.mutate, loginError: mutationLogin.error, logout };
};
